import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { REACT_APP_API_URL } from "../../../../../env";
import { useNavigate } from "react-router-dom";

const RescheduleList = () => {
  const [rescheduleData, setRescheduleData] = useState([]);
  const [filterText, setFilterText] = useState("");

  const navigate = useNavigate();

  const formatDate = (date) =>
    date ? date.split("T")[0].split("-").reverse().join("-") : "";

  useEffect(() => {
    const fetchList = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/history/hotel-reschedule`
        );
        setRescheduleData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching reschedule list:", error);
      }
    };
    fetchList();
  }, []);

  const customStyles = {
    rows: {
      style: {
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        position: "sticky",
        top: 0,
        zIndex: 1,
        whiteSpace: "nowrap",
        overflow: "visible",
        textOverflow: "clip",
      },
    },
    headRow: {
      style: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        border: "1px solid #dee2e6",
      },
    },
  };

  const filteredData = rescheduleData.filter((item) =>
    item.vchCustomerName.toLowerCase().includes(filterText.toLowerCase())
  );
  const columns = [
    {
      name: "Booking Ref No",
      selector: (row) => row.vchBookingRefNo,
      sortable: true,
    },
    {
      name: "Hotel",
      selector: (row) => row.vchHotelName,
    },
    {
      name: "Customer Name",
      selector: (row) => row.vchCustomerName,
      sortable: true,
    },
    // {
    //   name: "Email",
    //   selector: (row) => row.vchEmailID,
    // },
    // {
    //   name: "Mobile",
    //   selector: (row) => row.vchMobileNo,
    // },
    {
      name: "Total Rooms",
      selector: (row) => row.intNoOfRoom,
    },
    {
      name: "Old Check-In",
      selector: (row) => formatDate(row.OldCheckInDate),
    },
    {
      name: "New Check-In",
      selector: (row) => formatDate(row.dtNewCheckInDate),
    },
    {
      name: "Request Date",
      selector: (row) => formatDate(row.dtRescheduleDate),
    },
    {
      name: "Remark",
      selector: (row) =>
        row.vchReason ||
        row.vchRemark ||
        row.remark ||
        row.Remark ||
        "-",
      wrap: true,
    },
    {
      name: "Action",
      width: "180px",
      cell: (row) =>
        row.rescheduleStatus === 0 ? (
          <button
            className="btn btn-primary btn-sm"
            onClick={() =>
              navigate(`/reschedule/${row.vchBookingRefNo}`, {
                state: { newCheckIn: row.dtNewCheckInDate },
              })
            }
          >
            Reschedule
          </button>
        ) : (
          <button className="btn btn-secondary btn-sm" disabled>
            Rescheduled
          </button>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Rescheduling Requests</h2>
      <div className="card p-3">
        <div className="card-body mb-3 mt-3 ">
          <div className="mb-3">
            <input
              type="text"
              style={{ width: "300px" }}
              className="form-control"
              placeholder="Search by Customer Name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={100}
          paginationRowsPerPageOptions={[50, 100, 500]}
          striped
          highlightOnHover
          responsive
          customStyles={customStyles}
          noDataComponent="No list found."
          fixedHeader
          fixedHeaderScrollHeight="500px"
        />
      </div>
    </div>
  );
};

export default RescheduleList;
